export const ASSET_TYPE = {
  PICTURE: 'Picture',
  VIDEO: 'Video',
  COMPOSITION: 'Composition'
};
